import * as React from "react";

function SvgCwdChatDragHandle(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}><circle cx={9} cy={5} r={1.6} /><circle cx={9} cy={12} r={1.6} /><circle cx={9} cy={19} r={1.6} /><circle cx={15} cy={5} r={1.6} /><circle cx={15} cy={12} r={1.6} /><circle cx={15} cy={19} r={1.6} /></svg>;
}

export default SvgCwdChatDragHandle;